<template>
  <div class="langswitcher">
    <language-switch
      :language-codes="config.locales.helper.supportedLanguageIdents()"
      @lang-changed="handleLangChange"
    />
  </div>
</template>

<script>
import LanguageSwitch from 'components/LanguageSwitch.vue';
import config from 'config/appConfig';
import changeLanguage from 'utils/locale/changeLanguage';

export default {
  name: 'HeaderLanguageSelect',
  components: {
    LanguageSwitch,
  },
  data() {
    return {
      config,
    };
  },
  methods: {
    handleLangChange(lang) {
      changeLanguage({
        lng: lang.toString().toLowerCase(), reRoute: true, store: this.$store, i18n: this.$i18n, router: this.$router, reload: (lang !== 'db'),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  /deep/.btn .flex-container {
    line-height: inherit !important;
    height: inherit !important;
    font-size: inherit;
    display: flex;
    flex-direction: column;// (von oben nach unten)
    justify-content: center;
    align-items: center;

    @media #{$media_lg_min} {
      flex-direction: row;// (von links nach rechts = Standardwert)
    }

    .icon {
      line-height: inherit;
      height: inherit;
      width: auto;
    }
  }
  .langswitcher /deep/ .lang-dropdown{
    z-index: 1115;
  }
</style>
